// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___XWRoA","root_carousel":"style-module__root_carousel____TP05","root__creator":"style-module__root__creator___gmidF","root__creator__info":"style-module__root__creator__info___K6Tqg","root__creator__avatar":"style-module__root__creator__avatar___zovAO","root__creator__name":"style-module__root__creator__name___eZwWw"};
    if(module.hot) {
      // 1744730405030
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  